<template>
    <b-container class="list" fluid>
        <b-row class="list-item" :id="id">
            <b-col v-for="(item, itemIndex) in items" :key="itemIndex" class="col" :cols="cols" :class="item.active">
                <a :href="item.parentPath + item.slug" onclick="return false">
                    <b-card
                            @click="handleClick(item.slug, $event)"
                            :img-src="item.imgSrc"
                            img-alt="Image"
                            img-top
                            :overlay="item.isOverlay"
                            tag="article"
                            style="min-width: 6.8rem;"
                    >
                        <slot :card="item"></slot>
                    </b-card>
                </a>

            </b-col>
        </b-row>
        <div class="left control" v-if="control && items.length > 12/cols" @click="handleScroll('left')"></div>
        <div class="right control" v-if="control && items.length > 12/cols" @click="handleScroll('right')"></div>
    </b-container>
</template>
<script>
    export default {
        name: 'scrollList',
        props: {
            items: Array,
            cols: Number,
            control: Boolean,
        },
        data() {
            return {
                id: this.randomString(8)
            }
        },
        methods: {
            handleClick(slug, event) {
                if (event.target.tagName === 'IMG' || event.target.className.indexOf('card-img-overlay') !== -1) {
                    this.$emit('click', slug)
                }
            },
            handleScroll(direction) {
                console.log('this.id:', this.id)
                const row = document.getElementById(this.id)
                if (direction === 'left') {
                    //row.scrollLeft = row.clientWidth
                    this.animate(row, 0)
                } else {
                    //row.scrollLeft = row.clientWidth
                    this.animate(row, row.scrollWidth - row.clientWidth)
                }
            },
            randomString(len) {
                len = len || 32
                let $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
                /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
                let maxPos = $chars.length
                let pwd = ''
                for (let i = 0; i < len; i++) {
                    pwd += $chars.charAt(Math.floor(Math.random() * maxPos))
                }
                return pwd
            },
            animate(ele, target) {
                //1.清除定时器并设置定时器函数
                clearInterval(ele.timer)
                ele.timer = setInterval(function () {
                    //2.处理步长
                    let step = (target - ele.scrollLeft) / 10
                    step = step > 0 ? Math.ceil(step) : Math.floor(step)
                    //3.if函数判断当前位置
                    if (Math.abs(target - ele.scrollLeft) <= Math.abs(step)) {
                        ele.scrollLeft = target
                        clearInterval(ele.timer)
                    } else {
                        ele.scrollLeft = ele.scrollLeft + step
                    }
                }, 20)
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../../assets/style/var";

    .en {
        .list {
            .list-item {
                .col {
                    .card {
                        .card-body {
                            padding: 20px 10px 0 10px !important;
                        }
                    }
                    .card-text {
                        margin-bottom: 10px;
                        .desc {
                            font-size: 12px !important;
                        }
                    }
                }
            }

            .tag {
                font-size: 11px !important;
            }
        }
    }

    .row {
        margin-left: auto;
        margin-right: auto;
    }

    .list {
        position: relative;
        margin: 20px 0;
        //padding-bottom: 30%;
        overflow: hidden;

        .tag {
            position: absolute;
            top: 13px;
            left: 13px;
            font-size: 12px;
            line-height: 21px;
            color: rgba(0, 0, 0, 0.5);
        }

        .control {
            position: absolute;
            top: 35%;
            width: 50px;
            height: 50px;
            background-image: url("../../assets/img/common/arrow_right.png");
            background-size: cover;
            cursor: pointer;
            opacity: .7;
            transition: opacity .3s;
            &:hover {
                opacity: 1;
            }

            &.left {
                left: 30px;
                transform: translate(0, -50%) rotate(180deg);
            }

            &.right {
                right: 30px;
                transform: translate(0, -50%);
            }
        }

        > .title {
            padding: 40px 0 0 0;

            .list-title {
                padding: 0 @list-title-padding-left;
                font-size: @list-title-font-size;
                text-align: left;
            }

            .list-redirect {
                padding: 0 @list-title-padding-left;
                font-size: @list-title-redirect-font-size;
                color: @list-title-redirect-color;
                text-align: right;
            }
        }

        .list-item {
            //position: absolute;
            //top: 0;
            //left: @page-padding;
            //right: @page-padding;
            //bottom: -10px;
            flex-wrap: nowrap;
            overflow-x: scroll;
            -webkit-overflow-scrolling: touch;

            &::-webkit-scrollbar {display:none}

            .col {
                padding: 0 5px;

                &.active {
                    border: .5px solid @primary-dark-color;
                }

                &:nth-child(1) {
                    margin-left: 0;
                }

                img {
                    background: #F6F6F6;
                    border-radius: 0;
                    cursor: pointer;
                }

                .card {
                    border: none;
                    text-align: left;

                    .card-body {
                        padding: @list-title-padding-left 10px 0 10px;
                    }
                }

                .card-text {
                    margin-bottom: 2px;
                    .title {
                        padding-top: 0 !important;
                        font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif;
                        font-size: 16px;
                        line-height: @list-item-title-line-height;
                    }

                    .label {
                        font-size: 16px;
                    }

                    .desc {
                        display: inline-block;
                        margin-top: @list-item-sub-desc-margin-top;
                        font-size: 12px;
                        line-height: 18px;
                    }
                }
            }
        }
    }
</style>
